var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownToLineLightFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 576C504.8 576 512 568.8 512 560C512 551.2 504.8 544 496 544L144 544C135.2 544 128 551.2 128 560C128 568.8 135.2 576 144 576L496 576zM308.7 443.3C314.9 449.5 325.1 449.5 331.3 443.3L475.3 299.3C481.5 293.1 481.5 282.9 475.3 276.7C469.1 270.5 458.9 270.5 452.7 276.7L336 393.4L336 80C336 71.2 328.8 64 320 64C311.2 64 304 71.2 304 80L304 393.4L187.3 276.7C181.1 270.5 170.9 270.5 164.7 276.7C158.5 282.9 158.5 293.1 164.7 299.3L308.7 443.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownToLineLightFull);
export default __webpack_public_path__ + "static/media/arrow-down-to-line-light-full.7b7b471ec21ebac78b53c90d8d3424d5.svg";
export { ForwardRef as ReactComponent };